import React, { useState, useEffect } from 'react';

const GalleryV = () => {
    const videos = [
        { id: 1, url: 'https://drive.google.com/file/d/1BGZvh4VrCxEh3OmGewC1_o1mJd82z5IV/view?usp=sharing', title: 'Ciduk Quotes', description: 'Ciduk Warior Quotes' },
        { id: 2, url: 'https://drive.google.com/file/d/1F6RumLARIBcINrTExvuWdty6_k9Hvezl/view?usp=sharing', title: 'Obito Tak Segampang Itu (Rock Version)', description: 'Obito Tak Segampang Itu (Rock Version)' },
        { id: 3, url: 'https://drive.google.com/file/d/17N9Ak_le8cvHxexGznvjt0C4XyWJopmP/view?usp=sharing', title: 'N69 Fuck This Love Story', description: 'N69 Fuck This Love Story' },
        { id: 4, url: 'https://drive.google.com/file/d/1A1tnIs9gm0LF4asUEyo0QN5Vz43WCrKG/view?usp=sharing', title: 'N69 FCK', description: 'N69 FCK' },
        { id: 5, url: 'https://drive.google.com/file/d/1_-odV9ia2YkCLo0aTi-NBHzpIvd9jkkY/view?usp=sharing', title: 'I Can’t Stop the Loneliness', description: 'I Can’t Stop the Loneliness' },
        { id: 6, url: 'https://drive.google.com/file/d/1zMiYgLVW2lVomkCCW_pQy8SJ2H6U3MfE/view?usp=sharing', title: 'A Thousand Year (Speed Up Edit)', description: 'A Thousand Year (Speed Up Edit)' },
        { id: 7, url: 'https://drive.google.com/file/d/1CtGDYNe6EEN8GkSKjqcBt6wGACe2Is4D/view?usp=sharing', title: 'SkinnyN69', description: 'SkinnyN69' },
        { id: 8, url: 'https://drive.google.com/file/d/1feRfKURvlYqCKnGyJ_S4pKoeCkLUsKJT/view?usp=sharing', title: 'Jadi Badut Njir', description: 'Jadi Badut Njir' },
        { id: 9, url: 'https://drive.google.com/file/d/1OyQ8jFlcRiqXUQqEvZtWmssdRC91sXHT/view?usp=sharing', title: 'Susah Tidur hari ke 69', description: 'Susah Tidur hari ke 69' },
        { id: 10, url: 'https://drive.google.com/file/d/1spfTBrcKgkuEXyDsUE5eIBZO-P8YMSDe/view?usp=sharing', title: 'Update Project SR 2.3', description: 'Update Project SR 2.3 New Update displaying text "MIDNIGHT" when "00:00" and if time is "00:00" display will reset to normal display' },
        { id: 11, url: 'https://drive.google.com/file/d/1_NPtK5OfY7SKVRURwfxskCwWUF0DQhCg/view?usp=sharing', title: 'Air Keruh di Balas Air Mani', description: 'Blud memberikan sedikit kejahilan kecil dengan melistrik blud lainnya, lantas blud yang di listrik oleh blud ke satu membalas dengan memberinya sebutir peluru 9MM tepat ke arah kepala blud' },
        { id: 12, url: 'https://drive.google.com/file/d/1TZ2KclbrAXkHkiom1S3aGvo2ConZp52L/view?usp=sharing', title: 'Giveaway Stiker NFC', description: 'Blud memberikan stiker NFC secara cuma cuma kepada teman blud, akan tetapi stiker NFC tersebut meledak mengenai mobil blud lainnya, dan blud enggan untuk mengganti kerugian yang di alami oleh blud lain'},
        { id: 13, url: 'https://drive.google.com/file/d/1ivxsMLbundoBqALhf1ddjYZC6h2-Kp87/view?usp=sharing', title: 'Ketawa Akhir Hayat', description: 'Orang sesak nafas dipaksa ketawa sama keadaan'},
        { id: 14, url: 'https://drive.google.com/file/d/1H2urWJn_lGEscB9qf_joYOZfuNfmzCtd/view?usp=sharing', title: 'Cupang Jawa', description: 'Cupang hitam legam manis aseli majalengka'},
        { id: 15, url: 'https://drive.google.com/file/d/1fQFmPgOwGOKcUeSXnzuVkr2rxKZarw6d/view?usp=sharing', title: 'Mada Kono Sekaiwa', description: 'Bang lari bang ada meteor, Mada Kono Sekaiwa, anjir wibu'},
        { id: 16, url: 'https://drive.google.com/file/d/11Yk9pfVdSDVWu0Fp5NTyWVH02A60YHWl/view?usp=sharing', title: 'Let GO', description: 'Central Cee - Let Go'},
        { id: 17, url: 'https://drive.google.com/file/d/1QYQrGUBUTzrR7N6PpINiEaI1vsKTRtzS/view?usp=sharing', title: 'London View', description: 'TPL BM OTP - London View'},
        { id: 18, url: 'https://drive.google.com/file/d/1bnQ-neTIw0kqILRn_FQtVfsBdMRwzRzV/view?usp=sharing', title: 'Mockingbird(Remix)', description: '3x3 - Mockingbird(Remix)'},
        { id: 19, url: 'https://drive.google.com/file/d/1bDKkVoiOdH_surggbaV1b5QaMLQYXtE2/view?usp=sharing', title: 'I Can’t Save You', description: 'Lil Salmonella - I Can’t Save You'},
        { id: 20, url: 'https://drive.google.com/file/d/1scpl6620tCo3ucXgTcwG8d4iSA2tA3JE/view?usp=sharing', title: 'Event Sidoarjo Japanese World', description: 'Ngevent with tomodachi di sidoarjo. cihuyyy😋😋😋<br><br>edited by : <img url="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" style="width: 13px; height: 13px; margin-right: -1px;"> <a href="https://www.instagram.com/rizz_kph/?__pwa=1" target="_blank" rel="noopener noreferrer">rizz_kph</a>'},
        { id: 21, url: 'https://drive.google.com/file/d/1mhV2y8plEjztTNx841lzCvsfaNWVSQQr/view?usp=sharing', title: 'Event Animek C.Kai', description: 'Ngevent with tomodachi again di kediri. cihuyyy😋😋😋'},
    ];

    const [currentVideo, setCurrentVideo] = useState(null);
    const [thumbnails, setThumbnails] = useState({});

    useEffect(() => {
        const loadThumbnails = async () => {
            const thumbnailsTemp = {};
            for (const video of videos) {
                if (video.url) {
                    thumbnailsTemp[video.id] = await getVideoThumbnail(video.url);
                }
            }
            setThumbnails(thumbnailsTemp);
        };

        loadThumbnails();
    }, []);

    const openModal = (video) => {
        setCurrentVideo(video);
    };

    const closeModal = () => {
        setCurrentVideo(null);
    };

    const getVideoThumbnail = (videourl) => {
        const isGoogleDrive = videourl.includes('drive.google.com');
        if (isGoogleDrive) {
            return Promise.resolve('https://via.placeholder.com/150');
        }

        const video = document.createElement('video');
        video.url = videourl;
        video.setAttribute('preload', 'metadata');

        return new Promise((resolve) => {
            video.onloadedmetadata = () => {
                video.currentTime = 1;
                video.onseeked = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    const thumbnail = canvas.toDataURL('image/png');
                    resolve(thumbnail);
                };
            };
        });
    };

    const formatGoogleDriveUrl = (url) => {
        if (url.includes('drive.google.com')) {
            return url.replace(/\/file\/d\/([\w-]+)(\/.*)?/, '/file/d/$1/preview');
        }
        return url;
    };

    return (
        <div className="galleryv-bg" id='gallery'>
            <div data-aos="zoom-in-up">
                <h5 className="galleryv-font">Video</h5>
            </div>
            <div className="galleryv" data-aos="zoom-out">
                {videos.map((video) => (
                    <div key={video.id} className="video-container">
                        <img
                            src={thumbnails[video.id]}
                            alt={video.title}
                            className="thumbnail"
                            onClick={() => openModal(video)}
                        />
                        <div className="video-info">
                            <h6 className="video-title">{video.title}</h6>
                            <p className="video-description" dangerouslySetInnerHTML={{ __html: video.description }} ></p>
                        </div>
                    </div>
                ))}
            </div>
            {currentVideo && (
                <div className="modal-galleryv">
                    <div className="modal-content">
                        <span className="close" onClick={closeModal}>&times;</span>
                        {currentVideo.url.includes('drive.google.com') ? (
                            <iframe
                                src={formatGoogleDriveUrl(currentVideo.url)}
                                width="100%"
                                height="400"
                                title={currentVideo.title}
                                frameBorder="0"
                                allow="autoplay"
                                allowFullScreen
                            ></iframe>
                        ) : (
                            <video src={currentVideo.url} controls autoPlay className="modal-video" />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default GalleryV;